import { render, staticRenderFns } from "./FeaturedBlogPostsStacked.vue?vue&type=template&id=4b560482&scoped=true"
import script from "./FeaturedBlogPostsStacked.vue?vue&type=script&lang=js"
export * from "./FeaturedBlogPostsStacked.vue?vue&type=script&lang=js"
import style0 from "./FeaturedBlogPostsStacked.vue?vue&type=style&index=0&id=4b560482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b560482",
  null
  
)

export default component.exports